import ProcessorsContainer from "./ProcessorsContainer";

export default ProcessorsContainer;
